/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceEventQueueState } from './PriceEventQueueState';
import {
    PriceEventQueueStateFromJSON,
    PriceEventQueueStateFromJSONTyped,
    PriceEventQueueStateToJSON,
    PriceEventQueueStateToJSONTyped,
} from './PriceEventQueueState';

/**
 * 
 * @export
 * @interface PriceEventQueueStatusResponse
 */
export interface PriceEventQueueStatusResponse {
    /**
     * 
     * @type {PriceEventQueueState}
     * @memberof PriceEventQueueStatusResponse
     */
    state: PriceEventQueueState;
    /**
     * 
     * @type {Date}
     * @memberof PriceEventQueueStatusResponse
     */
    blockedSince?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PriceEventQueueStatusResponse
     */
    updatedAt?: Date | null;
}



/**
 * Check if a given object implements the PriceEventQueueStatusResponse interface.
 */
export function instanceOfPriceEventQueueStatusResponse(value: object): value is PriceEventQueueStatusResponse {
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function PriceEventQueueStatusResponseFromJSON(json: any): PriceEventQueueStatusResponse {
    return PriceEventQueueStatusResponseFromJSONTyped(json, false);
}

export function PriceEventQueueStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceEventQueueStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'state': PriceEventQueueStateFromJSON(json['state']),
        'blockedSince': json['blockedSince'] == null ? undefined : (new Date(json['blockedSince'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function PriceEventQueueStatusResponseToJSON(json: any): PriceEventQueueStatusResponse {
    return PriceEventQueueStatusResponseToJSONTyped(json, false);
}

export function PriceEventQueueStatusResponseToJSONTyped(value?: PriceEventQueueStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': PriceEventQueueStateToJSON(value['state']),
        'blockedSince': value['blockedSince'] == null ? undefined : ((value['blockedSince'] as any).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

